// extracted by mini-css-extract-plugin
export default {"title":"Online_title__Sd5Ha"};